import { render, staticRenderFns } from "./WialonTab.vue?vue&type=template&id=8a628512&scoped=true"
import script from "./WialonTab.vue?vue&type=script&lang=js"
export * from "./WialonTab.vue?vue&type=script&lang=js"
import style0 from "./WialonTab.vue?vue&type=style&index=0&id=8a628512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a628512",
  null
  
)

export default component.exports